/*eslint-disable*/
import React from 'react'
import { Modal, Button, Icon } from 'semantic-ui-react'

const AddModal = (props) => {
    return (
        <>
            <Modal {...props}>
                {props.children}
            </Modal>
        </>
    )
}

export default AddModal
